export default class scrollmagie {

    constructor() {
        var controller = new ScrollMagic.Controller();
        $('.animate').each(function (i, ele) {
            new ScrollMagic.Scene({
                triggerElement: ele,
                offset: $(ele).data('transform-offset') || -400,
                duration: $(ele).data('transform-duration') || "100%"
            })
            // .addIndicators()
            .setTween($(ele), 1, {
                x: $(ele).data('transform-x') || 0,
                y: $(ele).data('transform-y') || 0,
                opacity: $(ele).data('opacity') || 1,
            }).addTo(controller);
        })
    }
}


// WEBPACK FOOTER //
// ./src/scripts/helpers/scrollmagie.js